import React, { Component } from "react";
import Select from "react-select";
import AppContext from "../../../contexts/AppContext";
import { manageCredits } from "../../../services/billing";

class CreditModal extends Component {
    _isMounted = false;
    constructor(props) {
        super(props);
        this.state = {
            item: {
                credit_id: "",                                
            },
            price: 0.00,
            balance: 0,
            errors: {},
            success: {},
            isLoading: false,
            isDisabled: false,
            selectedValue: "",
        };
    }
    

    handleValidation(){
        let fields = this.state.item;
        let errors = {};
        let formIsValid = true;  
        
        if(!fields.credit_id){
            formIsValid = false;
            errors.credit_id = "Please select credit plan";
        }       

        this.setState({errors: errors});
        return formIsValid;
    } 
    
    getCurrentDate(separator='/'){

        let newDate = new Date()
        let date = newDate.getDate();
        let month = newDate.getMonth() + 1;
        let year = newDate.getFullYear() + 1;
        
        return `${month<10?`0${month}`:`${month}`}${separator}${date}${separator}${year}`
    }

    componentDidMount() {
        this._isMounted = true;       
        let data = this.props.listData;
        let selectedOption = data[0];
        let temp = this.state.item;       
        temp.credit_id = selectedOption.value;      
        let error = this.state.errors;

        if(this.props.curCredit + selectedOption.balance > 80)
        {
            error.credit_id = "Max allowed limit of purchase credit is 80.";
            this.setState({ item: temp, isDisabled: true, selectedValue: selectedOption, errors: error, price:0, balance:this.props.curCredit });
            
        }else{            
            error.credit_id = null;  
            this.setState({ item: temp, isDisabled: false, selectedValue: selectedOption, errors: error, price:selectedOption.price, balance:this.props.curCredit + selectedOption.balance }); 
        }  

        //error.credit_id = null;        
        //this.setState({ item: temp, selectedValue: selectedOption, errors: error, price:selectedOption.price, balance:this.props.curCredit + selectedOption.balance });
        
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    create = e => {
        e.preventDefault();
        if(this.handleValidation()){
            this.setState({ isLoading: true, isDisabled: true });
            manageCredits({
                credit_id: this.state.item.credit_id,                
            })
                .then(res => {
                    this.setState({ isLoading: false, isDisabled: false });
                    this.props.hideCreate();
                    this.props.setCredits();
                })
                .catch(error => {
                    this.setState({ isLoading: false, isDisabled: false });
                    this.props.hideCreate();                    
                    this.context.state.handelError(error);
                });
            
        }
        
    };

    handleChange = selectedOption => {
        let err = {};
        let temp = this.state.item;
        temp.credit_id = selectedOption.value;
        if(this.props.curCredit + selectedOption.balance > 80)
        {
            err.credit_id = "Max allowed limit of purchase credit is 80.";
            this.setState({ item: temp, isDisabled: true, selectedValue: selectedOption, errors: err, price:0, balance:this.props.curCredit });
            
        }else{            
            err.credit_id = null;  
            this.setState({ item: temp, isDisabled: false, selectedValue: selectedOption, errors: err, price:selectedOption.price, balance:this.props.curCredit + selectedOption.balance }); 
        }  
        
    }


    render() {
        return (
            <div className="model-container model-center model-backdrop-show">
                <div
                    aria-labelledby="model-title"
                    aria-describedby="model-content"
                    className="model-popup model-modal model-show"
                    role="dialog"
                    aria-live="assertive"
                    aria-modal="true"
                >
                    <h2 className="mb-4">Buy Credits</h2>
                    <div className="model-content">
                        <form onSubmit={this.create}>
                            <div className="form-group">
                                <label htmlFor="availableCredits">Your available Credits</label>                                
                                <span className="form-control-plaintext p-0">{this.props.curCredit}</span>
                            </div>
							<div className="form-group">
                                <label htmlFor="name">Select the amount to buy</label>
                                <Select
                                                styles={{
                                                    control: base => ({
                                                        ...base,
                                                        "&:hover": {
                                                            borderColor:
                                                                "#1cd2ad",
                                                            boxShadow: "none"
                                                        },
                                                        "&": {
                                                            borderColor:
                                                                "#d2ddec",
                                                            boxShadow: "0 0 5px 0 rgb(0,0,0,.2)"
                                                        }
                                                    }),
                                                    dropdownIndicator: base => ({
                                                        ...base,
                                                        color: "inherit"
                                                    }),
                                                    singleValue: base => ({
                                                        ...base,
                                                        color: "inherit"
                                                    })
                                                }}
                                                name="credit_id"
                                                id="credit_id"
                                                placeholder="Select the number of Credits"
                                                value={this.state.selectedValue}
                                                onChange={
                                                    this.handleChange
                                                }
                                                options={
                                                    this.props.listData
                                                }
                                            ></Select>
                                            {this.state.errors.credit_id ? (
                                            <div className="text-danger mt-2">
                                                {this.state.errors.credit_id || ''}
                                            </div>
                                        ) : null}
                            </div>
							<div className="form-group">
                                <label htmlFor="accountCharged">Your account will be charged</label>
                                <span className="form-control-plaintext p-0">${this.state.price}</span>                                
                            </div>
							<div className="form-group">
                                <label htmlFor="newBalance">Your new Credits balance will be</label>
                                <span className="form-control-plaintext p-0">{this.state.balance}</span>                                
                            </div>
							<div className="form-group">
                                <label htmlFor="expireOn">These Credits will expire on</label>
                                            <span className="form-control-plaintext p-0">{this.getCurrentDate()}</span>
                                
                            </div>
                            <p className="mb-4"><small>This bundle of Credits will expire 1 year from today. Unused Credits rollover to the next month (maximum of 80). <span><a href="https://faq.prowriter.co/knowledge-base/using-credits/" target="_blank">Learn More</a></span></small></p>
							<p className="mb-4"><small>You're authorizing ProWriter to charge your account. The full amount will be charged to your primary billing method <span><a href="https://faq.prowriter.co/knowledge-base/using-credits/" target="_blank">Learn More</a></span></small></p>
                            <button
                                type="button"
                                onClick={this.create}
                                disabled={this.state.isDisabled}
                                className="btn btn-primary mr-2"
                            >
                                {this.state.isLoading ? "Processing..." : "Buy Credits"}
                            </button>
                            
                            <button
                                type="button"
                                onClick={this.props.hideCreate}
                                className="btn btn-default"
                                disabled={this.state.isLoading}                
                            >
                                Cancel
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}
CreditModal.contextType = AppContext;
export default CreditModal;



// WEBPACK FOOTER //
// ./src/components/writer/credits/CreditModal.js